import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationControllerService } from '@iota/iota-management-portal-v4-client';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, take } from 'rxjs';
import { LoadIotaConfig, LoadIotaConfigFailure, LoadIotaConfigSuccess } from '../actions/iota-config.actions';

@Injectable()
export class IotaConfigEffects {
    loadIotaConfig$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadIotaConfig),
            mergeMap(() =>
                this.apiService.configFile('iota-config-v2.json').pipe(
                    take(1),
                    map((iotaConfigString: string) => {
                        try {
                            return LoadIotaConfigSuccess({ iotaConfig: JSON.parse(iotaConfigString) });
                        } catch (error) {
                            return LoadIotaConfigFailure({ error });
                        }
                    }),
                    catchError((error) => of(LoadIotaConfigFailure({ error })))
                )
            )
        )
    );
    constructor(
        private actions$: Actions,
        private httpClient: HttpClient,
        private apiService: ConfigurationControllerService
    ) {}
}
